import React from 'react';

const PrivacyPolicy: React.FC = () => {
  return (
    <div className="min-h-screen bg-slate-50 py-16 px-4 font-sans">
      <div className="max-w-3xl mx-auto bg-white rounded-3xl shadow-xl border border-slate-100 overflow-hidden">
        <div className="bg-brand-900 p-8 text-center">
          <h1 className="text-3xl font-black text-white tracking-tight">Privacy Policy</h1>
          <p className="text-brand-200 text-sm mt-2 font-bold uppercase tracking-widest">Effective Date: May 20, 2024</p>
        </div>
        
        <div className="p-8 md:p-12 space-y-8 text-slate-700 leading-relaxed">
          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-3">1. Information We Collect</h2>
            <p>We collect information that identifies, relates to, describes, or could reasonably be linked, directly or indirectly, with a particular consumer or household. This includes:</p>
            <ul className="list-disc ml-6 mt-2 space-y-2">
              <li><strong>Identifiers:</strong> Real name, alias, postal address, unique personal identifier, online identifier, IP address, email address, social security number, or other similar identifiers.</li>
              <li><strong>Financial Information:</strong> Tax documents, income statements, bank account numbers, and other sensitive data required for tax preparation.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-3">2. How We Use Your Information</h2>
            <p>Your information is used strictly for the purpose of providing professional tax preparation and filing services. This includes:</p>
            <ul className="list-disc ml-6 mt-2 space-y-2">
              <li>Processing and filing your tax returns with relevant authorities.</li>
              <li>Communicating status updates and requesting missing documentation.</li>
              <li>Ensuring the security of our portal and preventing fraudulent activity.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-3">3. Data Security and Storage</h2>
            <p>FilersHub employs bank-grade encryption (AES-256) for data at rest and TLS for data in transit. All documents are stored in secure, VPC-isolated environments. Access is restricted to authorized tax professionals assigned to your specific case.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-3">4. Disclosure of Information</h2>
            <p>We do not sell your personal information. We disclose information to third parties only as required by law (e.g., to the IRS or state tax agencies) or with your explicit written consent.</p>
          </section>

          <div className="pt-8 border-t border-slate-100 text-center">
            <button 
              onClick={() => window.location.href = '/'}
              className="text-brand-600 font-bold hover:underline"
            >
              Return to Login
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;